export default __webpack_public_path__ + "static/media/commercial-building-cropped.d3df7610.jpg";